/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { AlertminerApiConfiguration as __Configuration } from '../alertminer-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DealerSmtpSettingCustomDto } from '../models/dealer-smtp-setting-custom-dto';
@Injectable({
  providedIn: 'root',
})
class DealerSmtpSettingClientService extends __BaseService {
  static readonly GetDealerSmtpSettingsGETPath = '/api/DealerSmtpSetting/GetDealerSmtpSettings';
  static readonly SaveDealerSmtpSettingsPOSTPath = '/api/DealerSmtpSetting/SaveDealerSmtpSettings';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param dealerId undefined
   */
  GetDealerSmtpSettingsGETResponse(dealerId?: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (dealerId != null) __params = __params.set('dealerId', dealerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DealerSmtpSetting/GetDealerSmtpSettings`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param dealerId undefined
   */
  GetDealerSmtpSettingsGET(dealerId?: number): __Observable<null> {
    return this.GetDealerSmtpSettingsGETResponse(dealerId).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param request undefined
   */
  SaveDealerSmtpSettingsPOSTResponse(request?: DealerSmtpSettingCustomDto): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DealerSmtpSetting/SaveDealerSmtpSettings`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SaveDealerSmtpSettingsPOST(request?: DealerSmtpSettingCustomDto): __Observable<null> {
    return this.SaveDealerSmtpSettingsPOSTResponse(request).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module DealerSmtpSettingClientService {
}

export { DealerSmtpSettingClientService }
